module.exports = __webpack_public_path__ + "img/transport_pic03.252afe2c.png";